import src from "IMAGE";
export default { src, width: 418, height: 120, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AJ/B0b7L4NbV7cjH57e24NHQ66+t3dTU7QCko9icm9Wcm9Wgn9akotiendaenNWVlNKfISPVREaWIAAAAABJRU5ErkJggg=="};
